import { useEffect, useRef, useState } from "react";
import { Input } from "../../../BP2Components";
import { Icon_Edit } from "../../../BP2Components/Icons/icons";

import "./EditableField.less";

const EditableField = ({ fieldValue, onAccept }) => {
   const [isEdit, setIsEdit] = useState(false);
   const [value, setValue] = useState(fieldValue);
   const inputRef = useRef(null);

   const handleAccept = () => {
      onAccept(value);
      setIsEdit(false);
   };

   const handleCancel = () => {
      setValue(fieldValue);
      setIsEdit(false);
   };

   useEffect(() => {
      if (isEdit && inputRef.current) {
         inputRef.current.focus();
      }
   }, [isEdit]);

   useEffect(() => {
      setValue(fieldValue);
   }, [fieldValue]);

   return isEdit ? (
      <div className="editable-field-input-wrapper">
         <Input
            ref={inputRef}
            defaultValue={value}
            onChange={(e) => {
               setValue(e.target.value);
            }}
            onBlur={handleAccept}
            onKeyDown={(e) => {
               if (e.key === "Enter") handleAccept();
               if (e.key === "Escape") handleCancel();
            }}
         />
      </div>
   ) : (
      <p>
         {value}
         <button onClick={() => setIsEdit(true)}>
            <Icon_Edit />
         </button>
      </p>
   );
};

export default EditableField;
